export default function OrderedListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
    >
      <g transform="translate(-2 -4)">
        <path
          fill="currentColor"
          d="M8 7h12a1 1 0 000-2H8a1 1 0 000 2zm12 10H8a1 1 0 000 2h12a1 1 0 000-2zm0-6H8a1 1 0 000 2h12a1 1 0 000-2zM4.5 16h-2a.5.5 0 000 1H4v.5h-.5a.5.5 0 000 1H4v.5H2.5a.5.5 0 000 1h2a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5zm-2-11H3v2.5a.5.5 0 001 0v-3a.5.5 0 00-.5-.5h-1a.5.5 0 000 1zm2 5h-2a.5.5 0 000 1h1.3l-1.68 1.96a.49.49 0 00-.12.32v.22a.5.5 0 00.5.5h2a.5.5 0 000-1H3.2l1.68-1.96a.49.49 0 00.12-.32v-.22a.5.5 0 00-.5-.5z"
          data-name="Path 10635"
        ></path>
      </g>
    </svg>
  );
}
